<template>
  <div class="member_autocomplate">
      <autocomplete
      source="/api/members-search?q="
      placeholder="Αναζήτησε"
      resultsValue="id"
      :results-display="formattedMemberDisplay"
      @selected="goToMember"
      >
        <li slot="noResults">Δεν βρέθηκαν αποτελέσματα..</li>
      </autocomplete>
  </div>
</template>
<script>
    import Autocomplete from 'vuejs-auto-complete'
    export default {
        components: {
            Autocomplete,
        },
        mounted() {
        },
        methods: {
            formattedMemberDisplay (result) {
                return result.first_name + ' ' + result.last_name;
            },
            goToMember(member) {
              this.$router.push({ path: member.selectedObject.slug })
            }
        }
    }
</script>
<style lang="scss">
.member_autocomplate {
    .autocomplete {
        &__box {  
          position: relative;
          background: none!important;
          border-bottom: 3px solid #68BF99!important;
          border-top: 0!important;
          border-left: 0!important;
          border-right: 0!important;
          &:after {
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            width: 60px;
            transform: translateY(-50%);
            background-image: url('/images/search_icon.svg');
          }
        }
        &__inputs {
          input {
            width: 100%;
            border: 0;
            font-size: 48px;
            // color: #68BF99;
            background: transparent;
            padding: 10px 10px;
            height: auto;
            line-height: 1;
            @media(max-width:992px){
              font-size: 30px;
            }
            @media(max-width:768px){
              font-size: 20px;
              margin-left: -10px;
            }
          }
        }
        &__icon {
          // display: none;
          width: 30px!important;
          height: 30px!important;
          filter: brightness(0);
          @media(max-width:768px){ 
            transform: scale(0.6);
            margin-left: -10px;
          } 
          // order: 2;
        }
        &__results {
            font-size: 16px;
        }
        &--clear {
            margin-right: 10px;
        }
        .autocomplete__searching {
          .autocomplete__icon {
            // opacity: 0;
          }
          .autocomplete--clear {
            // opacity: 1!important;
          }
        }
        .autocomplete__results {
          border-bottom-left-radius: 20px;
          border-bottom-right-radius: 20px;
          border-color: #68BF99;
          border-width: 2px;
          &__item {
            transition: background 0.2s ease;
            margin: 8px 10px;
            &:hover {
              background: #F7F3DF!important;
            }
          }
        }
        
    }
}
</style>